import { FunctionComponent } from 'react'
import { useAppHandlers } from '../../../../../services/actions/app/useAppHandlers';
import CustomModal from "../../../CustomModal";
import { useNavigate } from 'react-router-dom';


const SubscriptionCanceledSection: FunctionComponent = () => {
    const navigate = useNavigate()

    return (
        <CustomModal
            headingText={'Your subscription has been canceled.'}
            closeButton
            confirmButton={{
                text: 'Got it',
                mediumButton: true,
                onClickHandler: () => navigate(0)
            }}
        >
        </CustomModal>
    )

}

export default SubscriptionCanceledSection